import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getProducts = (query) => {
  const queryParams = new URLSearchParams();
  
  // Add pagination parameters
  if (query.currentPage) queryParams.append('page', query.currentPage);
  if (query.itemsPerPage) queryParams.append('limit', query.itemsPerPage);
  
  // Add sorting parameters
  if (query.sortBy) queryParams.append('sortBy', query.sortBy);
  if (query.sortOrder) queryParams.append('sortOrder', query.sortOrder);
  
  // Add search parameters
  if (query.search) queryParams.append('search', query.search);
  if (query.status) queryParams.append('status', query.status);
  if (query.rnd1_username) queryParams.append('rnd1_username', query.rnd1_username);
  if (query.rnd2_username) queryParams.append('rnd2_username', query.rnd2_username);
  if (query.supplier_id) queryParams.append('supplier_id', query.supplier_id);
  
  const queryString = queryParams.toString();
  const url = queryString ? 
    `${getApiUrl()}/api/tkt1-product/get?${queryString}` : 
    `${getApiUrl()}/api/tkt1-product/get`;
    
  return API.get(url);
};

export const getProductByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-product/${id}`);
};

export const getProductByMID = (mid) => {
  return API.get(`${getApiUrl()}/api/tkt1-product/mid/${mid}`);
};

export const createProduct = (productData) => {
  return API.post(`${getApiUrl()}/api/tkt1-product/`, productData);
};

export const updateProduct = (id, productData) => {
  return API.put(`${getApiUrl()}/api/tkt1-product/${id}`, productData);
};

export const updateProductByMID = (mid, productData) => {
  return API.put(`${getApiUrl()}/api/tkt1-product/mid/${mid}`, productData);
};

export const deleteProduct = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-product/${id}`);
};

export const searchProducts = (searchQuery) => {
  const queryParams = new URLSearchParams();
  
  if (searchQuery.search) queryParams.append('search', searchQuery.search);
  if (searchQuery.status) queryParams.append('status', searchQuery.status);
  if (searchQuery.rnd1_username) queryParams.append('rnd1_username', searchQuery.rnd1_username);
  if (searchQuery.rnd2_username) queryParams.append('rnd2_username', searchQuery.rnd2_username);
  if (searchQuery.supplier_id) queryParams.append('supplier_id', searchQuery.supplier_id);
  
  const queryString = queryParams.toString();
  const url = queryString ? 
    `${getApiUrl()}/api/tkt1-product/search?${queryString}` : 
    `${getApiUrl()}/api/tkt1-product/search`;
    
  return API.get(url);
};

export const tkt1ProductService = {
  getProducts,
  getProductByID,
  getProductByMID,
  createProduct,
  updateProduct,
  updateProductByMID,
  deleteProduct,
  searchProducts
};
